/**
 * GxAvatar: a person's initials in a circle (top bar, presence stacks, "edited by" lines). Colour comes from a fixed set by index; each pairs a
 * categorical colour with the initials ink that clears 4.5:1 on it (contrast.md). c5 and c6 clear 4.5:1 with neither ink, so avatars skip them.
 */
const AVATAR_TONES = [
  { background: "var(--c1)", color: "var(--white)" }, { background: "var(--c4)", color: "var(--white)" }, { background: "var(--c3)", color: "var(--ink)" },
  { background: "var(--navy-600)", color: "var(--white)" }, { background: "var(--c2)", color: "var(--ink)" },
] as const;

/** "R. Elm" → "RE". */
const initials = (name: string): string => name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]?.toUpperCase() ?? "").join("");

export function GxAvatar({ name, size = "md", colorIndex, online = true }: {
  readonly name: string; readonly size?: "md" | "sm" | "xs"; readonly colorIndex?: number; readonly online?: boolean;
}) {
  const className = ["gx-avatar", size === "md" ? "" : `gx-avatar--${size}`, online ? "" : "gx-avatar--offline"].filter(Boolean).join(" ");
  const style = colorIndex === undefined || !online ? undefined : AVATAR_TONES[colorIndex % AVATAR_TONES.length];
  const label = online ? name : `${name} (offline)`;
  return <span className={className} role="img" aria-label={label} title={label} style={style}>{initials(name)}</span>;
}

export function GxAvatarStack({ people, max = 4, label }: { readonly people: readonly { readonly name: string; readonly online?: boolean }[]; readonly max?: number; readonly label?: string }) {
  return <span className="gx-avstack" role={label === undefined ? undefined : "group"} aria-label={label}>{people.slice(0, max).map((p, i) => <GxAvatar key={`${p.name}-${i}`} name={p.name} size="sm" colorIndex={i} online={p.online ?? true} />)}</span>;
}
